<div class="component-main-container">
  <div class="header">
    <app-page-header parentTitle="{{ 'logs.logs-parent-label' | translate }}"
      pageTitle="{{ 'logs.form-filter-equipment' | translate }}">
    </app-page-header>
  </div>
  <!--Corpo do componente-->
  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <app-logs-form></app-logs-form>

        <div class="form-fields-box" [ngClass]="!filterBox ? 'closed' : ''" [formGroup]="filterLogsForm">
          <h2 (click)="filterBoxOpen()">
            {{ "logs.form-filter-label" | translate }}
          </h2>
          <hr [ngClass]="!filterBox ? 'hr-open' : ''" />

          <div class="form-step">
            <mat-form-field appearance="outline" class="example-form-field">
              <mat-label>{{ "logs.form-operation" | translate }}</mat-label>

              <mat-select formControlName="operation" name="operation">
                <mat-option value="">{{
                  "logs.form-filter-null" | translate
                  }}</mat-option>
                <mat-option value="CREATE">{{
                  "logs.form-create-label" | translate
                  }}</mat-option>
                <mat-option value="UPDATE">{{
                  "logs.form-update-label" | translate
                  }}</mat-option>
                <mat-option value="DELETE">{{
                  "logs.form-delete-label" | translate
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="date-picker-input">
              <p-datepicker inputId="calendar-24h" selectionMode="range" formControlName="logsDateTime" appendTo="body"
                placeholder="{{ 'logs.form-date' | translate }}" showIcon iconDisplay="input" dateFormat="dd/mm/yy" />
            </div>
          </div>

          <div class="form-step">
            <mat-form-field appearance="outline">
              <mat-label>{{ "logs.form-serialNumber" | translate }}</mat-label>
              <input matInput formControlName="serialNumber" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <mat-form-field appearance="outline">
              <mat-label>{{ "logs.form-macAddress" | translate }}</mat-label>
              <input matInput formControlName="macAddress" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <mat-form-field appearance="outline">
              <mat-label>{{ "logs.form-filter-user" | translate }}</mat-label>
              <input matInput formControlName="username" />
            </mat-form-field>
          </div>

          @if (!filterLoading) {
          <button title="{{ 'logs.form-filter-button' | translate }}" class="btn btn-success"
            (click)="filterEquipmentLogs(null)">
            {{ "logs.form-filter-button" | translate }}
          </button>
          }
          @if (filterLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    <!-- Sessão tabela -->
    @if (paginationProperties.total) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [loadingData$]="fileLoading" [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData(null, 'CSV')"
        (downloadPDF)="generateFileData(null, 'PDF')"></app-table-header>
      @if (filterLoading) {
      <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
      }
      <div class="table-container mt-2 mt-lg-3 mt-xl-3">
        <p-table [value]="ELEMENT_DATA" [rows]="pageSize" [totalRecords]="length" dataKey="id" [paginator]="true"
          (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="username"> {{ "logs.form-filter-user" | translate }}</th>
              <th pSortableColumn="operation">{{ "logs.form-operation" | translate }}</th>
              <th pSortableColumn="logDatetime">{{ "logs.form-logDatetime" | translate }}</th>
              <th pSortableColumn="serialNumber">{{ "logs.form-serialNumber" | translate }}</th>
              <th pSortableColumn="macAddress">{{ "logs.form-macAddress" | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>{{row.username}}</td>
              <td>{{ getTranslationKey(row) | translate }}</td>
              <td>{{formatDate(row.logDatetime)}}</td>
              <td>{{row.serialNumber}}</td>
              <td>{{row.macAddress}}</td>
          </ng-template>
        </p-table>
      </div>
    </div>
    }
  </div>
</div>